import React, { Component } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import { Elements, StripeProvider } from "react-stripe-elements";
import CheckoutForm from "../../components/Payments/CheckoutForm";
import styled from 'styled-components'
import Image from 'react-bootstrap/Image'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'

const StyledContainer = styled(Container)`
  padding-right:0;
  padding-left:0;
  margin-right:auto;
  margin-left:auto;
  overflow: hidden;
  position: relative;
  justifyContent: 'center';
`

const Flyer = styled(Image)`

`

const MainCol = styled(Col)`
    align-items: center;    
`

const Divider = styled(Row)`
    padding: 3%;
    border: 3%;
`

const RightDivider = styled.hr`
    color: #d3d3d3;
    background-color: #d3d3d3;
    height: 2px;
`
const LeftDivider = styled.hr`
    color: transparent;
    background-color: transparent;
    height: 2px;
`


export default class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.props.location.state.allData,
            subtotal: 0,
            total: 0,
            quantity: '',
            tax: 0,
        }
    }

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value })
    }





    render() {

        let parsed = parseInt(this.state.quantity, 10);
        if (isNaN(parsed)) parsed = 0
        let total = (parsed * this.state.eventPrice * 1.06)
        return (

            <StyledContainer>
                <Row>
                    <Col>

                        <p>
                            {this.state.eventDate}
                        </p>
                        <p>
                            {this.state.startTime}
                        </p>
                    </Col>
                    <MainCol xs={6}>
                        <Flyer src={this.state.eventFlyer} fluid />
                        <Row>
                            <Col>
                                <p>
                                    Price
                                    </p>
                                <p>
                                    {`$${this.state.eventPrice}`}
                                </p>
                            </Col>
                            <Col />
                            <Col>
                                <p>
                                    No. of tickets
                                    </p>
                                <InputGroup>
                                    <Form.Control
                                        aria-label="Default"
                                        aria-describedby="inputGroup-sizing-default"
                                        onChange={this.onChange}
                                        defaultValue="0"
                                        value={this.state.quantity}
                                        name="quantity"
                                        ref={input => this.quantity = input}
                                    />
                                </InputGroup>
                                <RightDivider />

                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <p>
                                    Subtotal
                                    </p>
                                <p>
                                    Tax
                                    </p>
                                <p>
                                    Total
                                    </p>
                            </Col>
                            <Col />
                            <Col>
                                <p>
                                    {(parsed * this.state.eventPrice).toFixed(2)}
                                </p>
                                <p>
                                    {(parsed * this.state.eventPrice * 0.06).toFixed(2)}
                                </p>
                                <p>
                                    {total.toFixed(2)}
                                </p>
                            </Col>
                        </Row>
                        <Elements>
                            <CheckoutForm />
                        </Elements>
                        <Divider />
                    </MainCol>
                    <Col>
                        <p>
                            {this.state.eventAddress}
                        </p>
                        <p>
                            {`${this.state.eventCity}, ${this.state.eventState}`}
                        </p>
                    </Col>
                </Row>
            </StyledContainer>




        )
    }
}
